import useTranslation from "../../../../hooks/i18n/useTranslation";
import "../../styles/Settings.css";
import { TextHeader } from "../../components/text-header/TextHeader";
import { TimezoneSelector } from "../../components/timezone-selector/TimezoneSelector";

export const Region = () => {
    const { t } = useTranslation();

    return (
        <div className="settings-container-item settings-container-region">
            <TextHeader title={t("279")} content={t("280")} />
            <div className="settings-region-content">
                <TimezoneSelector className="settings-dropdown-selector" />
            </div>
        </div>
    )
}